import React, { useCallback, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";

import { FormControlLabel } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import EditColumn from "../../common/EditColumn";
import { MediaContext } from "../../common/media-context";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    padding: theme.spacing(3),
  },

  header: {
    textTransform: "uppercase",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.primary.darker,
    marginBottom: theme.spacing(2),
  },

  label: {
    fontSize: "14px",
    lineHeight: "18px",
  },

  checkbox: {
    "& svg": {
      height: "18px",
      width: "18px",
    },
  },
}));

const EditModuleDetailsCheckboxes = props => {
  const classes = useStyles();
  const context = useContext(MediaContext);

  const formBuilder = useCallback(
    handlers => {
      return (
        <Grid container>
          <Grid item container direction="column" xs={6}>
            <Grid item>
              <div>Include In</div>
            </Grid>
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={context.media.inDplaCatalog}
                    onChange={handlers.onCheckboxChange("inDplaCatalog")}
                    name="module-inDplaCatalog"
                    inputProps={{ "aria-label": "Select" }}
                    classes={{ root: classes.checkbox }}
                  />
                }
                label="DPLA Catalog"
                classes={{ label: classes.label }}
              />
            </Grid>
          </Grid>
          <Grid item container direction="column" xs={6}>
            <Grid item>
              <div>Exclude From</div>
            </Grid>
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={context.media.excludeFromCatalog}
                    onChange={handlers.onCheckboxChange("excludeFromCatalog")}
                    name="module-excludeFromCatalog"
                    inputProps={{ "aria-label": "Select" }}
                    classes={{ root: classes.checkbox }}
                  />
                }
                label="BiblioBoard Catalog"
                classes={{ label: classes.label }}
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={context.media.hideInPatronModuleList}
                    onChange={handlers.onCheckboxChange(
                      "hideInPatronModuleList",
                    )}
                    name="module-hideInPatronModuleList"
                    inputProps={{ "aria-label": "Select" }}
                    classes={{ root: classes.checkbox }}
                  />
                }
                label="Patron Module List"
                classes={{ label: classes.label }}
              />
            </Grid>
          </Grid>
        </Grid>
      );
    },
    [context, classes],
  );

  return <EditColumn className={classes.root} formBuilder={formBuilder} />;
};

export default EditModuleDetailsCheckboxes;
